module.exports = __webpack_public_path__ + "images/xibao_top_semi_backview_2026-2027.1791972770245.jpg";